import { auditSupport } from '@mi-front/api-clients';
import { ValidateAndUploadFileView } from '../ValidateAndUploadFileView';
import { AvgPreview } from './AvgPreview';
import { Station } from '@app/core/types/stations';

export function AvgUpload({ station }: { station: Station }) {
  return (
    <ValidateAndUploadFileView<
      auditSupport.MinUploadAvgResultDto,
      { data: auditSupport.BulkUploadAvgFilesMutationRequest }
    >
      station={station}
      accept=".avg,.AVG,.avg.txt,.AVG.TXT,text/plain"
      fileType="AVG"
      useUploadMutation={auditSupport.useBulkUploadAvgFiles}
      renderPreview={(data) => <AvgPreview entries={data.entries ?? []} />}
    />
  );
}
